import { Radio } from "antd";
import React from "react";
import SelectSlotChip from "../../../atoms/chip/select-slot-chip";
import useQueueStore from "../../../stores/queue-store";
import { track } from "../../../utils/tracking";
import { Section } from "./select-slot";
import useGetQueueConfig from "../../../apis/tryst/get-queue-config";
import { useCreateAptStore } from "@elixir/stores";

/**
 * The use of flex here instead of dr-flex is intentionals
 * Will be changing it soon with class specificity
 */

const durationsInMinutes = [5, 7, 10, 15, 20, 25, 30, 45, 60];

const VisitDuration = () => {
  const customSlotDuration = useQueueStore((state) => state.customSlotDuration);
  const setCustomSlotDuration = useQueueStore(
    (state) => state.setCustomSlotDuration
  );
  const clearSelectedSlot = useQueueStore((state) => state.clearSelectedSlot);

  const { data: queueConfigData, isLoading: isQueueConfigLoading } =
    useGetQueueConfig();
  const selectedDoctor = useCreateAptStore((state) => state.selectedDoctor);

  const slotDurations = React.useMemo(() => {
    let slotDurations: number[] = [];
    const doctorsSlotConfig = queueConfigData?.data?.slot_config;
    if (doctorsSlotConfig) {
      const selectedDoctorOid = selectedDoctor?.oid;
      if (selectedDoctorOid && doctorsSlotConfig[selectedDoctorOid]) {
        slotDurations = doctorsSlotConfig[selectedDoctorOid].durations;
      }
    }

    if (!slotDurations.length) {
      slotDurations = durationsInMinutes;
    }

    if (!slotDurations.includes(customSlotDuration)) {
      setCustomSlotDuration(slotDurations[0]);
    }

    return slotDurations;
  }, [queueConfigData?.data?.slot_config, selectedDoctor]);

  return (
    <Section title="Visit Duration" outerClassname="dr-px-16">
      {isQueueConfigLoading ? (
        <div className="animate dr-h-32 dr-w-full dr-rounded-8" />
      ) : (
        <Radio.Group
          optionType="button"
          buttonStyle="solid"
          className="dr-space-x-12 flex items-center"
          onChange={(e) => {
            track("select_duration", {
              duration: e.target.value,
            });
            setCustomSlotDuration(e.target.value);
            clearSelectedSlot();
          }}
          value={customSlotDuration}
        >
          {slotDurations.map((duration) => (
            <SelectSlotChip key={duration} value={duration}>
              {`${duration}m`}
            </SelectSlotChip>
          ))}
        </Radio.Group>
      )}
    </Section>
  );
};

export default VisitDuration;
